// API service for animated spritesheet uploads
const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001'

class SpritesheetApi {
  constructor() {
    this.broadcasterLogin = null
  }

  setBroadcasterLogin(login) {
    this.broadcasterLogin = login
  }

  // Get all spritesheets for a critter type
  async getSpritesheets(critterType) {
    if (!this.broadcasterLogin) {
      console.warn('Broadcaster login not set')
      return {}
    }

    try {
      const response = await fetch(
        `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/spritesheets/${critterType}`
      )

      if (!response.ok) {
        if (response.status === 404) return {}
        throw new Error(`Failed to fetch spritesheets: ${response.status}`)
      }

      return await response.json()
    } catch (error) {
      console.error('Error fetching spritesheets:', error)
      return {}
    }
  }

  // Get all critter types that have spritesheets
  async getCritterTypesWithSpritesheets() {
    if (!this.broadcasterLogin) {
      console.warn('Broadcaster login not set')
      return []
    }

    try {
      const response = await fetch(
        `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/spritesheets`
      )

      if (!response.ok) {
        throw new Error(`Failed to fetch spritesheet list: ${response.status}`)
      }

      return await response.json()
    } catch (error) {
      console.error('Error fetching spritesheet list:', error)
      return []
    }
  }

  // Upload a spritesheet for a critter type and animation state
  async uploadSpritesheet(critterType, animationState, pngFile, jsonFile) {
    if (!this.broadcasterLogin) {
      throw new Error('Broadcaster login not set')
    }

    const formData = new FormData()
    formData.append('critterType', critterType)
    formData.append('animationState', animationState)
    formData.append('spritesheet', pngFile)
    formData.append('metadata', jsonFile)

    const response = await fetch(
      `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/spritesheets`,
      {
        method: 'POST',
        body: formData
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to upload spritesheet')
    }

    return await response.json()
  }

  // Delete a spritesheet
  async deleteSpritesheet(critterType, animationState) {
    if (!this.broadcasterLogin) {
      throw new Error('Broadcaster login not set')
    }

    const response = await fetch(
      `${API_BASE}/twitch/api/broadcaster/${this.broadcasterLogin}/spritesheets/${critterType}/${animationState}`,
      {
        method: 'DELETE'
      }
    )

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error.error || 'Failed to delete spritesheet')
    }

    return true
  }
}

export const spritesheetApi = new SpritesheetApi()
